var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Причина деактивации")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.comment,
              expression: "comment",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.comment = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.change_slug,
                expression: "change_slug",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.change_slug)
                ? _vm._i(_vm.change_slug, null) > -1
                : _vm.change_slug,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.change_slug,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.change_slug = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.change_slug = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.change_slug = $$c
                }
              },
            },
          }),
          _vm._v(" сменить URL препарата на сайте\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Дата активации")]),
          _vm._v(" "),
          _c("DateSelectProps", {
            ref: "selectedDate",
            attrs: { disabled: true },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-1 text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Сохранить",
              type: "button",
              loading: _vm.btnLoading,
              color: _vm.$constants.PRIMARY_COLOR,
              onClick: () => _vm.saveRecord(),
              className: "btn btn-outline-info",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Установка таймера активации препарата")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }